"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var Wrapper = _stylitas.styled.div(function (_ref) {
  var templateAreas = _ref.templateAreas,
      templateColumns = _ref.templateColumns;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-column-gap: 8px;\n    grid-template-columns: ", ";\n    grid-template-areas: ", ";\n\n    ", ";\n  "])), (templateColumns == null ? void 0 : templateColumns.xs) || 'repeat(4, 1fr)', (templateAreas == null ? void 0 : templateAreas.xs) || 'none', _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      grid-template-columns: ", ";\n      grid-column-gap: 24px;\n      grid-template-areas: ", ";\n    "])), (templateColumns == null ? void 0 : templateColumns.md) || 'repeat(12, 1fr)', (templateAreas == null ? void 0 : templateAreas.md) || 'none'));
});

exports.Wrapper = Wrapper;